/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const addBuilding = /* GraphQL */ `
  mutation AddBuilding($input: AddBuildingInput) {
    addBuilding(input: $input) {
      Devices {
        items {
          airtable {
            analog_periods_without_data
            authorization_end_date
            automatic_upload
            building_tenths {
              building_tenth
              distribution_tenth
              distribution_tenth_comment
              organisation_tenant
              property_owner_tenth
              site_code
              site_id
              tenth
              __typename
            }
            consumption_2010_10years_in_kwh_pcs
            consumption_2011_10years_in_kwh_pcs
            consumption_2012_10years_in_kwh_pcs
            consumption_2013_10years_in_kwh_pcs
            consumption_2014_10years_in_kwh_pcs
            consumption_2015_10years_in_kwh_pcs
            consumption_2016_10years_in_kwh_pcs
            consumption_2017_10years_in_kwh_pcs
            consumption_2018_10years_in_kwh_pcs
            consumption_2019_10years_in_kwh_pcs
            consumption_2020_10years_in_kwh_pcs
            consumption_2021_10years_in_kwh_pcs
            consumption_2022_10years_in_kwh_pcs
            consumption_2023_10years_in_kwh_pcs
            consumption_2024_10years_in_kwh_pcs
            consumption_or_production
            contextual_information
            contract_holder
            current_synoptic_quality_reporting
            customer_space_available
            deet_category
            delegated_authorization
            deposited
            deposited_date
            destination
            distributor_name
            energy_data_upload_possibilities
            fluid_type
            functional_entities {
              code
              lots
              surface
              tenant_code
              tenant_name
              tertiary
              type
              __typename
            }
            injection_type
            last_analog_invoice_date
            named_authorization
            pdl_id
            perimeter_to_consider
            placement
            quality_of_data_completeness_2023
            questions_about_pdl_to_energy_manager
            site_code
            site_name
            site_rental_typology
            sites {
              address
              city
              code
              current_synoptic_quality_reporting
              id
              name
              organisation_tenant
              postal_code
              __typename
            }
            sub_metering
            supplier_name
            tenth
            unique_point
            usage
            __typename
          }
          analysis {
            meter_commissioning {
              created_at
              text
              __typename
            }
            __typename
          }
          buildingId
          destination
          deviceType
          fluidSupplierId
          fluidType
          fusionedEnergyQuality
          id
          name
          properties {
            id
            name
            quality {
              completenes_end_date
              completenes_start_date
              completeness
              completeness_end_date
              completeness_start_date
              ignored_intervals {
                end_date
                start_date
                __typename
              }
              missing_values
              outliers {
                timestamp
                unit
                value
                __typename
              }
              overall_quality
              overall_quality_reason
              timeseries_end_date
              timeseries_start_date
              __typename
            }
            unit
            value
            __typename
          }
          siteCode
          siteCodes
          siteId
          siteIds
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      id
      location {
        address
        city
        country
        latitude
        longitude
        zipcode
        __typename
      }
      name
      portfolioId
      __typename
    }
  }
`;
export const addDevice = /* GraphQL */ `
  mutation AddDevice($input: AddDeviceInput!) {
    addDevice(input: $input) {
      airtable {
        analog_periods_without_data
        authorization_end_date
        automatic_upload
        building_tenths {
          building_tenth
          distribution_tenth
          distribution_tenth_comment
          organisation_tenant
          property_owner_tenth
          site_code
          site_id
          tenth
          __typename
        }
        consumption_2010_10years_in_kwh_pcs
        consumption_2011_10years_in_kwh_pcs
        consumption_2012_10years_in_kwh_pcs
        consumption_2013_10years_in_kwh_pcs
        consumption_2014_10years_in_kwh_pcs
        consumption_2015_10years_in_kwh_pcs
        consumption_2016_10years_in_kwh_pcs
        consumption_2017_10years_in_kwh_pcs
        consumption_2018_10years_in_kwh_pcs
        consumption_2019_10years_in_kwh_pcs
        consumption_2020_10years_in_kwh_pcs
        consumption_2021_10years_in_kwh_pcs
        consumption_2022_10years_in_kwh_pcs
        consumption_2023_10years_in_kwh_pcs
        consumption_2024_10years_in_kwh_pcs
        consumption_or_production
        contextual_information
        contract_holder
        current_synoptic_quality_reporting
        customer_space_available
        deet_category
        delegated_authorization
        deposited
        deposited_date
        destination
        distributor_name
        energy_data_upload_possibilities
        fluid_type
        functional_entities {
          code
          lots
          surface
          tenant_code
          tenant_name
          tertiary
          type
          __typename
        }
        injection_type
        last_analog_invoice_date
        named_authorization
        pdl_id
        perimeter_to_consider
        placement
        quality_of_data_completeness_2023
        questions_about_pdl_to_energy_manager
        site_code
        site_name
        site_rental_typology
        sites {
          address
          city
          code
          current_synoptic_quality_reporting
          id
          name
          organisation_tenant
          postal_code
          __typename
        }
        sub_metering
        supplier_name
        tenth
        unique_point
        usage
        __typename
      }
      analysis {
        meter_commissioning {
          created_at
          text
          __typename
        }
        __typename
      }
      buildingId
      destination
      deviceType
      fluidSupplierId
      fluidType
      fusionedEnergyQuality
      id
      name
      properties {
        id
        name
        quality {
          completenes_end_date
          completenes_start_date
          completeness
          completeness_end_date
          completeness_start_date
          ignored_intervals {
            end_date
            start_date
            __typename
          }
          missing_values
          outliers {
            timestamp
            unit
            value
            __typename
          }
          overall_quality
          overall_quality_reason
          timeseries_end_date
          timeseries_start_date
          __typename
        }
        unit
        value
        __typename
      }
      siteCode
      siteCodes
      siteId
      siteIds
      __typename
    }
  }
`;
export const addDeviceQualityReasoning = /* GraphQL */ `
  mutation AddDeviceQualityReasoning($input: AddDeviceQualityReasoningInput) {
    addDeviceQualityReasoning(input: $input) {
      createAt
      endDate
      id
      outdated
      reasoningId
      reasoningText
      reasoningType
      reviewed
      startDate
      updateBy
      updatedAt
      value
      __typename
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      password {
        password
        username
        __typename
      }
      user {
        email
        enabled
        excludedPerimeter {
          devices
          sites
          __typename
        }
        id
        lastConnectionAt
        perimeter {
          devices
          sites
          __typename
        }
        role
        timeConstraintPerimeter {
          devices {
            id
            periods {
              endDate
              startDate
              __typename
            }
            __typename
          }
          sites {
            id
            periods {
              endDate
              startDate
              __typename
            }
            __typename
          }
          __typename
        }
        username
        __typename
      }
      __typename
    }
  }
`;
export const deleteBuilding = /* GraphQL */ `
  mutation DeleteBuilding($id: ID) {
    deleteBuilding(id: $id) {
      Devices {
        items {
          airtable {
            analog_periods_without_data
            authorization_end_date
            automatic_upload
            building_tenths {
              building_tenth
              distribution_tenth
              distribution_tenth_comment
              organisation_tenant
              property_owner_tenth
              site_code
              site_id
              tenth
              __typename
            }
            consumption_2010_10years_in_kwh_pcs
            consumption_2011_10years_in_kwh_pcs
            consumption_2012_10years_in_kwh_pcs
            consumption_2013_10years_in_kwh_pcs
            consumption_2014_10years_in_kwh_pcs
            consumption_2015_10years_in_kwh_pcs
            consumption_2016_10years_in_kwh_pcs
            consumption_2017_10years_in_kwh_pcs
            consumption_2018_10years_in_kwh_pcs
            consumption_2019_10years_in_kwh_pcs
            consumption_2020_10years_in_kwh_pcs
            consumption_2021_10years_in_kwh_pcs
            consumption_2022_10years_in_kwh_pcs
            consumption_2023_10years_in_kwh_pcs
            consumption_2024_10years_in_kwh_pcs
            consumption_or_production
            contextual_information
            contract_holder
            current_synoptic_quality_reporting
            customer_space_available
            deet_category
            delegated_authorization
            deposited
            deposited_date
            destination
            distributor_name
            energy_data_upload_possibilities
            fluid_type
            functional_entities {
              code
              lots
              surface
              tenant_code
              tenant_name
              tertiary
              type
              __typename
            }
            injection_type
            last_analog_invoice_date
            named_authorization
            pdl_id
            perimeter_to_consider
            placement
            quality_of_data_completeness_2023
            questions_about_pdl_to_energy_manager
            site_code
            site_name
            site_rental_typology
            sites {
              address
              city
              code
              current_synoptic_quality_reporting
              id
              name
              organisation_tenant
              postal_code
              __typename
            }
            sub_metering
            supplier_name
            tenth
            unique_point
            usage
            __typename
          }
          analysis {
            meter_commissioning {
              created_at
              text
              __typename
            }
            __typename
          }
          buildingId
          destination
          deviceType
          fluidSupplierId
          fluidType
          fusionedEnergyQuality
          id
          name
          properties {
            id
            name
            quality {
              completenes_end_date
              completenes_start_date
              completeness
              completeness_end_date
              completeness_start_date
              ignored_intervals {
                end_date
                start_date
                __typename
              }
              missing_values
              outliers {
                timestamp
                unit
                value
                __typename
              }
              overall_quality
              overall_quality_reason
              timeseries_end_date
              timeseries_start_date
              __typename
            }
            unit
            value
            __typename
          }
          siteCode
          siteCodes
          siteId
          siteIds
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      id
      location {
        address
        city
        country
        latitude
        longitude
        zipcode
        __typename
      }
      name
      portfolioId
      __typename
    }
  }
`;
export const deleteDevice = /* GraphQL */ `
  mutation DeleteDevice($id: ID!) {
    deleteDevice(id: $id) {
      airtable {
        analog_periods_without_data
        authorization_end_date
        automatic_upload
        building_tenths {
          building_tenth
          distribution_tenth
          distribution_tenth_comment
          organisation_tenant
          property_owner_tenth
          site_code
          site_id
          tenth
          __typename
        }
        consumption_2010_10years_in_kwh_pcs
        consumption_2011_10years_in_kwh_pcs
        consumption_2012_10years_in_kwh_pcs
        consumption_2013_10years_in_kwh_pcs
        consumption_2014_10years_in_kwh_pcs
        consumption_2015_10years_in_kwh_pcs
        consumption_2016_10years_in_kwh_pcs
        consumption_2017_10years_in_kwh_pcs
        consumption_2018_10years_in_kwh_pcs
        consumption_2019_10years_in_kwh_pcs
        consumption_2020_10years_in_kwh_pcs
        consumption_2021_10years_in_kwh_pcs
        consumption_2022_10years_in_kwh_pcs
        consumption_2023_10years_in_kwh_pcs
        consumption_2024_10years_in_kwh_pcs
        consumption_or_production
        contextual_information
        contract_holder
        current_synoptic_quality_reporting
        customer_space_available
        deet_category
        delegated_authorization
        deposited
        deposited_date
        destination
        distributor_name
        energy_data_upload_possibilities
        fluid_type
        functional_entities {
          code
          lots
          surface
          tenant_code
          tenant_name
          tertiary
          type
          __typename
        }
        injection_type
        last_analog_invoice_date
        named_authorization
        pdl_id
        perimeter_to_consider
        placement
        quality_of_data_completeness_2023
        questions_about_pdl_to_energy_manager
        site_code
        site_name
        site_rental_typology
        sites {
          address
          city
          code
          current_synoptic_quality_reporting
          id
          name
          organisation_tenant
          postal_code
          __typename
        }
        sub_metering
        supplier_name
        tenth
        unique_point
        usage
        __typename
      }
      analysis {
        meter_commissioning {
          created_at
          text
          __typename
        }
        __typename
      }
      buildingId
      destination
      deviceType
      fluidSupplierId
      fluidType
      fusionedEnergyQuality
      id
      name
      properties {
        id
        name
        quality {
          completenes_end_date
          completenes_start_date
          completeness
          completeness_end_date
          completeness_start_date
          ignored_intervals {
            end_date
            start_date
            __typename
          }
          missing_values
          outliers {
            timestamp
            unit
            value
            __typename
          }
          overall_quality
          overall_quality_reason
          timeseries_end_date
          timeseries_start_date
          __typename
        }
        unit
        value
        __typename
      }
      siteCode
      siteCodes
      siteId
      siteIds
      __typename
    }
  }
`;
export const deleteDeviceQualityReasoning = /* GraphQL */ `
  mutation DeleteDeviceQualityReasoning(
    $input: deleteDeviceQualityReasoningInput
  ) {
    deleteDeviceQualityReasoning(input: $input) {
      createAt
      endDate
      id
      outdated
      reasoningId
      reasoningText
      reasoningType
      reviewed
      startDate
      updateBy
      updatedAt
      value
      __typename
    }
  }
`;
export const publishGetDevicePropertyTimeseriesAsyncResult = /* GraphQL */ `
  mutation PublishGetDevicePropertyTimeseriesAsyncResult(
    $input: PublishGetDevicePropertyAsyncResultInput!
  ) {
    publishGetDevicePropertyTimeseriesAsyncResult(input: $input) {
      chunkCurrent
      chunkTotal
      id
      status
      timeseries {
        grid_name
        likelihood_index_season_base
        likelihood_index_season_hc
        likelihood_index_season_hcb
        likelihood_index_season_hce
        likelihood_index_season_hch
        likelihood_index_season_hp
        likelihood_index_season_hpb
        likelihood_index_season_hpe
        likelihood_index_season_hph
        likelihood_index_season_ja
        likelihood_index_season_p
        likelihood_index_season_pointe
        monotone_cumulative_time_in_min
        monotone_end_date
        monotone_execution_time
        monotone_start_date
        nature
        read_reason
        reason
        sampling_rate_in_min
        season_class_dict
        source
        time
        value
        value_nature_absence
        value_nature_actual
        value_nature_brut
        value_nature_corrected
        value_nature_corrige
        value_nature_coupure_secteur
        value_nature_coupure_secteur_courte
        value_nature_debut_de_coupure_secteur
        value_nature_esti
        value_nature_estimated
        value_nature_estime
        value_nature_fin_de_coupure_secteur
        value_nature_importe_manuellement_par_le_metier_enedis
        value_nature_no_data
        value_nature_puissance_reconstituee_et_coupure_secteur
        value_nature_reel
        value_nature_regu
        value_season_base
        value_season_hc
        value_season_hcb
        value_season_hce
        value_season_hch
        value_season_hp
        value_season_hpb
        value_season_hpe
        value_season_hph
        value_season_ja
        value_season_p
        value_season_pointe
        value_source_airtable_manual_bills
        value_source_airtable_third_party_active_power_in_kwh
        value_source_airtable_third_party_energy
        value_source_enedis_active_power_daily_in_kwh
        value_source_enedis_billed_energy
        __typename
      }
      token
      unit
      __typename
    }
  }
`;
export const streamAnalysis = /* GraphQL */ `
  mutation StreamAnalysis($input: StreamAnalysisInput) {
    streamAnalysis(input: $input) {
      analysisClass
      analysisType
      assistent_prompt
      id
      status
      system_prompt
      user_prompt
      __typename
    }
  }
`;
export const syncSubdevices = /* GraphQL */ `
  mutation SyncSubdevices($input: SyncSubdevicesInput) {
    syncSubdevices(input: $input) {
      changed {
        changedValues {
          building {
            new_value
            old_value
            __typename
          }
          contract_holder {
            new_value
            old_value
            __typename
          }
          description {
            new_value
            old_value
            __typename
          }
          deviceId {
            new_value
            old_value
            __typename
          }
          lessor {
            new_value
            old_value
            __typename
          }
          name {
            new_value
            old_value
            __typename
          }
          siteId {
            new_value
            old_value
            __typename
          }
          timeseries {
            new_value {
              grid_name
              likelihood_index_season_base
              likelihood_index_season_hc
              likelihood_index_season_hcb
              likelihood_index_season_hce
              likelihood_index_season_hch
              likelihood_index_season_hp
              likelihood_index_season_hpb
              likelihood_index_season_hpe
              likelihood_index_season_hph
              likelihood_index_season_ja
              likelihood_index_season_p
              likelihood_index_season_pointe
              monotone_cumulative_time_in_min
              monotone_end_date
              monotone_execution_time
              monotone_start_date
              nature
              read_reason
              reason
              sampling_rate_in_min
              season_class_dict
              source
              time
              value
              value_nature_absence
              value_nature_actual
              value_nature_brut
              value_nature_corrected
              value_nature_corrige
              value_nature_coupure_secteur
              value_nature_coupure_secteur_courte
              value_nature_debut_de_coupure_secteur
              value_nature_esti
              value_nature_estimated
              value_nature_estime
              value_nature_fin_de_coupure_secteur
              value_nature_importe_manuellement_par_le_metier_enedis
              value_nature_no_data
              value_nature_puissance_reconstituee_et_coupure_secteur
              value_nature_reel
              value_nature_regu
              value_season_base
              value_season_hc
              value_season_hcb
              value_season_hce
              value_season_hch
              value_season_hp
              value_season_hpb
              value_season_hpe
              value_season_hph
              value_season_ja
              value_season_p
              value_season_pointe
              value_source_airtable_manual_bills
              value_source_airtable_third_party_active_power_in_kwh
              value_source_airtable_third_party_energy
              value_source_enedis_active_power_daily_in_kwh
              value_source_enedis_billed_energy
              __typename
            }
            old_value {
              grid_name
              likelihood_index_season_base
              likelihood_index_season_hc
              likelihood_index_season_hcb
              likelihood_index_season_hce
              likelihood_index_season_hch
              likelihood_index_season_hp
              likelihood_index_season_hpb
              likelihood_index_season_hpe
              likelihood_index_season_hph
              likelihood_index_season_ja
              likelihood_index_season_p
              likelihood_index_season_pointe
              monotone_cumulative_time_in_min
              monotone_end_date
              monotone_execution_time
              monotone_start_date
              nature
              read_reason
              reason
              sampling_rate_in_min
              season_class_dict
              source
              time
              value
              value_nature_absence
              value_nature_actual
              value_nature_brut
              value_nature_corrected
              value_nature_corrige
              value_nature_coupure_secteur
              value_nature_coupure_secteur_courte
              value_nature_debut_de_coupure_secteur
              value_nature_esti
              value_nature_estimated
              value_nature_estime
              value_nature_fin_de_coupure_secteur
              value_nature_importe_manuellement_par_le_metier_enedis
              value_nature_no_data
              value_nature_puissance_reconstituee_et_coupure_secteur
              value_nature_reel
              value_nature_regu
              value_season_base
              value_season_hc
              value_season_hcb
              value_season_hce
              value_season_hch
              value_season_hp
              value_season_hpb
              value_season_hpe
              value_season_hph
              value_season_ja
              value_season_p
              value_season_pointe
              value_source_airtable_manual_bills
              value_source_airtable_third_party_active_power_in_kwh
              value_source_airtable_third_party_energy
              value_source_enedis_active_power_daily_in_kwh
              value_source_enedis_billed_energy
              __typename
            }
            __typename
          }
          __typename
        }
        id
        name
        sameValues {
          building
          contract_holder
          description
          deviceId
          id
          lessor
          name
          siteId
          timeseries {
            grid_name
            likelihood_index_season_base
            likelihood_index_season_hc
            likelihood_index_season_hcb
            likelihood_index_season_hce
            likelihood_index_season_hch
            likelihood_index_season_hp
            likelihood_index_season_hpb
            likelihood_index_season_hpe
            likelihood_index_season_hph
            likelihood_index_season_ja
            likelihood_index_season_p
            likelihood_index_season_pointe
            monotone_cumulative_time_in_min
            monotone_end_date
            monotone_execution_time
            monotone_start_date
            nature
            read_reason
            reason
            sampling_rate_in_min
            season_class_dict
            source
            time
            value
            value_nature_absence
            value_nature_actual
            value_nature_brut
            value_nature_corrected
            value_nature_corrige
            value_nature_coupure_secteur
            value_nature_coupure_secteur_courte
            value_nature_debut_de_coupure_secteur
            value_nature_esti
            value_nature_estimated
            value_nature_estime
            value_nature_fin_de_coupure_secteur
            value_nature_importe_manuellement_par_le_metier_enedis
            value_nature_no_data
            value_nature_puissance_reconstituee_et_coupure_secteur
            value_nature_reel
            value_nature_regu
            value_season_base
            value_season_hc
            value_season_hcb
            value_season_hce
            value_season_hch
            value_season_hp
            value_season_hpb
            value_season_hpe
            value_season_hph
            value_season_ja
            value_season_p
            value_season_pointe
            value_source_airtable_manual_bills
            value_source_airtable_third_party_active_power_in_kwh
            value_source_airtable_third_party_energy
            value_source_enedis_active_power_daily_in_kwh
            value_source_enedis_billed_energy
            __typename
          }
          __typename
        }
        __typename
      }
      items {
        building
        contract_holder
        description
        deviceId
        id
        lessor
        name
        siteId
        timeseries {
          grid_name
          likelihood_index_season_base
          likelihood_index_season_hc
          likelihood_index_season_hcb
          likelihood_index_season_hce
          likelihood_index_season_hch
          likelihood_index_season_hp
          likelihood_index_season_hpb
          likelihood_index_season_hpe
          likelihood_index_season_hph
          likelihood_index_season_ja
          likelihood_index_season_p
          likelihood_index_season_pointe
          monotone_cumulative_time_in_min
          monotone_end_date
          monotone_execution_time
          monotone_start_date
          nature
          read_reason
          reason
          sampling_rate_in_min
          season_class_dict
          source
          time
          value
          value_nature_absence
          value_nature_actual
          value_nature_brut
          value_nature_corrected
          value_nature_corrige
          value_nature_coupure_secteur
          value_nature_coupure_secteur_courte
          value_nature_debut_de_coupure_secteur
          value_nature_esti
          value_nature_estimated
          value_nature_estime
          value_nature_fin_de_coupure_secteur
          value_nature_importe_manuellement_par_le_metier_enedis
          value_nature_no_data
          value_nature_puissance_reconstituee_et_coupure_secteur
          value_nature_reel
          value_nature_regu
          value_season_base
          value_season_hc
          value_season_hcb
          value_season_hce
          value_season_hch
          value_season_hp
          value_season_hpb
          value_season_hpe
          value_season_hph
          value_season_ja
          value_season_p
          value_season_pointe
          value_source_airtable_manual_bills
          value_source_airtable_third_party_active_power_in_kwh
          value_source_airtable_third_party_energy
          value_source_enedis_active_power_daily_in_kwh
          value_source_enedis_billed_energy
          __typename
        }
        __typename
      }
      new {
        building
        contract_holder
        description
        deviceId
        id
        lessor
        name
        siteId
        timeseries {
          grid_name
          likelihood_index_season_base
          likelihood_index_season_hc
          likelihood_index_season_hcb
          likelihood_index_season_hce
          likelihood_index_season_hch
          likelihood_index_season_hp
          likelihood_index_season_hpb
          likelihood_index_season_hpe
          likelihood_index_season_hph
          likelihood_index_season_ja
          likelihood_index_season_p
          likelihood_index_season_pointe
          monotone_cumulative_time_in_min
          monotone_end_date
          monotone_execution_time
          monotone_start_date
          nature
          read_reason
          reason
          sampling_rate_in_min
          season_class_dict
          source
          time
          value
          value_nature_absence
          value_nature_actual
          value_nature_brut
          value_nature_corrected
          value_nature_corrige
          value_nature_coupure_secteur
          value_nature_coupure_secteur_courte
          value_nature_debut_de_coupure_secteur
          value_nature_esti
          value_nature_estimated
          value_nature_estime
          value_nature_fin_de_coupure_secteur
          value_nature_importe_manuellement_par_le_metier_enedis
          value_nature_no_data
          value_nature_puissance_reconstituee_et_coupure_secteur
          value_nature_reel
          value_nature_regu
          value_season_base
          value_season_hc
          value_season_hcb
          value_season_hce
          value_season_hch
          value_season_hp
          value_season_hpb
          value_season_hpe
          value_season_hph
          value_season_ja
          value_season_p
          value_season_pointe
          value_source_airtable_manual_bills
          value_source_airtable_third_party_active_power_in_kwh
          value_source_airtable_third_party_energy
          value_source_enedis_active_power_daily_in_kwh
          value_source_enedis_billed_energy
          __typename
        }
        __typename
      }
      same {
        building
        contract_holder
        description
        deviceId
        id
        lessor
        name
        siteId
        timeseries {
          grid_name
          likelihood_index_season_base
          likelihood_index_season_hc
          likelihood_index_season_hcb
          likelihood_index_season_hce
          likelihood_index_season_hch
          likelihood_index_season_hp
          likelihood_index_season_hpb
          likelihood_index_season_hpe
          likelihood_index_season_hph
          likelihood_index_season_ja
          likelihood_index_season_p
          likelihood_index_season_pointe
          monotone_cumulative_time_in_min
          monotone_end_date
          monotone_execution_time
          monotone_start_date
          nature
          read_reason
          reason
          sampling_rate_in_min
          season_class_dict
          source
          time
          value
          value_nature_absence
          value_nature_actual
          value_nature_brut
          value_nature_corrected
          value_nature_corrige
          value_nature_coupure_secteur
          value_nature_coupure_secteur_courte
          value_nature_debut_de_coupure_secteur
          value_nature_esti
          value_nature_estimated
          value_nature_estime
          value_nature_fin_de_coupure_secteur
          value_nature_importe_manuellement_par_le_metier_enedis
          value_nature_no_data
          value_nature_puissance_reconstituee_et_coupure_secteur
          value_nature_reel
          value_nature_regu
          value_season_base
          value_season_hc
          value_season_hcb
          value_season_hce
          value_season_hch
          value_season_hp
          value_season_hpb
          value_season_hpe
          value_season_hph
          value_season_ja
          value_season_p
          value_season_pointe
          value_source_airtable_manual_bills
          value_source_airtable_third_party_active_power_in_kwh
          value_source_airtable_third_party_energy
          value_source_enedis_active_power_daily_in_kwh
          value_source_enedis_billed_energy
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const syncSubdevicesTimeseries = /* GraphQL */ `
  mutation SyncSubdevicesTimeseries($input: SyncSubdevicesTimeseriesInput) {
    syncSubdevicesTimeseries(input: $input) {
      items {
        deviceId
        id
        nextToken
        pagination {
          nextToken
          startedAt
          __typename
        }
        propertyId
        timeseries {
          grid_name
          likelihood_index_season_base
          likelihood_index_season_hc
          likelihood_index_season_hcb
          likelihood_index_season_hce
          likelihood_index_season_hch
          likelihood_index_season_hp
          likelihood_index_season_hpb
          likelihood_index_season_hpe
          likelihood_index_season_hph
          likelihood_index_season_ja
          likelihood_index_season_p
          likelihood_index_season_pointe
          monotone_cumulative_time_in_min
          monotone_end_date
          monotone_execution_time
          monotone_start_date
          nature
          read_reason
          reason
          sampling_rate_in_min
          season_class_dict
          source
          time
          value
          value_nature_absence
          value_nature_actual
          value_nature_brut
          value_nature_corrected
          value_nature_corrige
          value_nature_coupure_secteur
          value_nature_coupure_secteur_courte
          value_nature_debut_de_coupure_secteur
          value_nature_esti
          value_nature_estimated
          value_nature_estime
          value_nature_fin_de_coupure_secteur
          value_nature_importe_manuellement_par_le_metier_enedis
          value_nature_no_data
          value_nature_puissance_reconstituee_et_coupure_secteur
          value_nature_reel
          value_nature_regu
          value_season_base
          value_season_hc
          value_season_hcb
          value_season_hce
          value_season_hch
          value_season_hp
          value_season_hpb
          value_season_hpe
          value_season_hph
          value_season_ja
          value_season_p
          value_season_pointe
          value_source_airtable_manual_bills
          value_source_airtable_third_party_active_power_in_kwh
          value_source_airtable_third_party_energy
          value_source_enedis_active_power_daily_in_kwh
          value_source_enedis_billed_energy
          __typename
        }
        unit
        __typename
      }
      nextToken
      scannedCount
      startedAt
      __typename
    }
  }
`;
export const syncUsers = /* GraphQL */ `
  mutation SyncUsers($input: SyncUsersInput) {
    syncUsers(input: $input) {
      changed_users {
        changed_values {
          email {
            new_value
            old_value
            __typename
          }
          enabled {
            new_value
            old_value
            __typename
          }
          excludedPerimeter {
            new_value {
              devices
              sites
              __typename
            }
            old_value {
              devices
              sites
              __typename
            }
            __typename
          }
          perimeter {
            new_value {
              devices
              sites
              __typename
            }
            old_value {
              devices
              sites
              __typename
            }
            __typename
          }
          role {
            new_value
            old_value
            __typename
          }
          timeConstraintPerimeter {
            new_value {
              devices {
                id
                periods {
                  endDate
                  startDate
                  __typename
                }
                __typename
              }
              sites {
                id
                periods {
                  endDate
                  startDate
                  __typename
                }
                __typename
              }
              __typename
            }
            old_value {
              devices {
                id
                periods {
                  endDate
                  startDate
                  __typename
                }
                __typename
              }
              sites {
                id
                periods {
                  endDate
                  startDate
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        id
        same_values {
          email
          enabled
          excludedPerimeter {
            devices
            sites
            __typename
          }
          id
          perimeter {
            devices
            sites
            __typename
          }
          role
          timeConstraintPerimeter {
            devices {
              id
              periods {
                endDate
                startDate
                __typename
              }
              __typename
            }
            sites {
              id
              periods {
                endDate
                startDate
                __typename
              }
              __typename
            }
            __typename
          }
          username
          __typename
        }
        username
        __typename
      }
      new_users {
        email
        enabled
        excludedPerimeter {
          devices
          sites
          __typename
        }
        id
        perimeter {
          devices
          sites
          __typename
        }
        role
        timeConstraintPerimeter {
          devices {
            id
            periods {
              endDate
              startDate
              __typename
            }
            __typename
          }
          sites {
            id
            periods {
              endDate
              startDate
              __typename
            }
            __typename
          }
          __typename
        }
        username
        __typename
      }
      passwords {
        password
        username
        __typename
      }
      same_users {
        email
        enabled
        excludedPerimeter {
          devices
          sites
          __typename
        }
        id
        perimeter {
          devices
          sites
          __typename
        }
        role
        timeConstraintPerimeter {
          devices {
            id
            periods {
              endDate
              startDate
              __typename
            }
            __typename
          }
          sites {
            id
            periods {
              endDate
              startDate
              __typename
            }
            __typename
          }
          __typename
        }
        username
        __typename
      }
      users {
        email
        enabled
        excludedPerimeter {
          devices
          sites
          __typename
        }
        id
        perimeter {
          devices
          sites
          __typename
        }
        role
        timeConstraintPerimeter {
          devices {
            id
            periods {
              endDate
              startDate
              __typename
            }
            __typename
          }
          sites {
            id
            periods {
              endDate
              startDate
              __typename
            }
            __typename
          }
          __typename
        }
        username
        __typename
      }
      __typename
    }
  }
`;
export const updateAnalysis = /* GraphQL */ `
  mutation UpdateAnalysis($input: UpdateAnalysisInput!) {
    updateAnalysis(input: $input) {
      analysisClass
      analysisType
      assistent_prompt
      id
      status
      system_prompt
      user_prompt
      __typename
    }
  }
`;
export const updateBuilding = /* GraphQL */ `
  mutation UpdateBuilding($input: UpdateBuildingInput!) {
    updateBuilding(input: $input) {
      Devices {
        items {
          airtable {
            analog_periods_without_data
            authorization_end_date
            automatic_upload
            building_tenths {
              building_tenth
              distribution_tenth
              distribution_tenth_comment
              organisation_tenant
              property_owner_tenth
              site_code
              site_id
              tenth
              __typename
            }
            consumption_2010_10years_in_kwh_pcs
            consumption_2011_10years_in_kwh_pcs
            consumption_2012_10years_in_kwh_pcs
            consumption_2013_10years_in_kwh_pcs
            consumption_2014_10years_in_kwh_pcs
            consumption_2015_10years_in_kwh_pcs
            consumption_2016_10years_in_kwh_pcs
            consumption_2017_10years_in_kwh_pcs
            consumption_2018_10years_in_kwh_pcs
            consumption_2019_10years_in_kwh_pcs
            consumption_2020_10years_in_kwh_pcs
            consumption_2021_10years_in_kwh_pcs
            consumption_2022_10years_in_kwh_pcs
            consumption_2023_10years_in_kwh_pcs
            consumption_2024_10years_in_kwh_pcs
            consumption_or_production
            contextual_information
            contract_holder
            current_synoptic_quality_reporting
            customer_space_available
            deet_category
            delegated_authorization
            deposited
            deposited_date
            destination
            distributor_name
            energy_data_upload_possibilities
            fluid_type
            functional_entities {
              code
              lots
              surface
              tenant_code
              tenant_name
              tertiary
              type
              __typename
            }
            injection_type
            last_analog_invoice_date
            named_authorization
            pdl_id
            perimeter_to_consider
            placement
            quality_of_data_completeness_2023
            questions_about_pdl_to_energy_manager
            site_code
            site_name
            site_rental_typology
            sites {
              address
              city
              code
              current_synoptic_quality_reporting
              id
              name
              organisation_tenant
              postal_code
              __typename
            }
            sub_metering
            supplier_name
            tenth
            unique_point
            usage
            __typename
          }
          analysis {
            meter_commissioning {
              created_at
              text
              __typename
            }
            __typename
          }
          buildingId
          destination
          deviceType
          fluidSupplierId
          fluidType
          fusionedEnergyQuality
          id
          name
          properties {
            id
            name
            quality {
              completenes_end_date
              completenes_start_date
              completeness
              completeness_end_date
              completeness_start_date
              ignored_intervals {
                end_date
                start_date
                __typename
              }
              missing_values
              outliers {
                timestamp
                unit
                value
                __typename
              }
              overall_quality
              overall_quality_reason
              timeseries_end_date
              timeseries_start_date
              __typename
            }
            unit
            value
            __typename
          }
          siteCode
          siteCodes
          siteId
          siteIds
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      id
      location {
        address
        city
        country
        latitude
        longitude
        zipcode
        __typename
      }
      name
      portfolioId
      __typename
    }
  }
`;
export const updateDevice = /* GraphQL */ `
  mutation UpdateDevice($input: UpdateDeviceInput!) {
    updateDevice(input: $input) {
      airtable {
        analog_periods_without_data
        authorization_end_date
        automatic_upload
        building_tenths {
          building_tenth
          distribution_tenth
          distribution_tenth_comment
          organisation_tenant
          property_owner_tenth
          site_code
          site_id
          tenth
          __typename
        }
        consumption_2010_10years_in_kwh_pcs
        consumption_2011_10years_in_kwh_pcs
        consumption_2012_10years_in_kwh_pcs
        consumption_2013_10years_in_kwh_pcs
        consumption_2014_10years_in_kwh_pcs
        consumption_2015_10years_in_kwh_pcs
        consumption_2016_10years_in_kwh_pcs
        consumption_2017_10years_in_kwh_pcs
        consumption_2018_10years_in_kwh_pcs
        consumption_2019_10years_in_kwh_pcs
        consumption_2020_10years_in_kwh_pcs
        consumption_2021_10years_in_kwh_pcs
        consumption_2022_10years_in_kwh_pcs
        consumption_2023_10years_in_kwh_pcs
        consumption_2024_10years_in_kwh_pcs
        consumption_or_production
        contextual_information
        contract_holder
        current_synoptic_quality_reporting
        customer_space_available
        deet_category
        delegated_authorization
        deposited
        deposited_date
        destination
        distributor_name
        energy_data_upload_possibilities
        fluid_type
        functional_entities {
          code
          lots
          surface
          tenant_code
          tenant_name
          tertiary
          type
          __typename
        }
        injection_type
        last_analog_invoice_date
        named_authorization
        pdl_id
        perimeter_to_consider
        placement
        quality_of_data_completeness_2023
        questions_about_pdl_to_energy_manager
        site_code
        site_name
        site_rental_typology
        sites {
          address
          city
          code
          current_synoptic_quality_reporting
          id
          name
          organisation_tenant
          postal_code
          __typename
        }
        sub_metering
        supplier_name
        tenth
        unique_point
        usage
        __typename
      }
      analysis {
        meter_commissioning {
          created_at
          text
          __typename
        }
        __typename
      }
      buildingId
      destination
      deviceType
      fluidSupplierId
      fluidType
      fusionedEnergyQuality
      id
      name
      properties {
        id
        name
        quality {
          completenes_end_date
          completenes_start_date
          completeness
          completeness_end_date
          completeness_start_date
          ignored_intervals {
            end_date
            start_date
            __typename
          }
          missing_values
          outliers {
            timestamp
            unit
            value
            __typename
          }
          overall_quality
          overall_quality_reason
          timeseries_end_date
          timeseries_start_date
          __typename
        }
        unit
        value
        __typename
      }
      siteCode
      siteCodes
      siteId
      siteIds
      __typename
    }
  }
`;
export const updateDeviceQualityReasoning = /* GraphQL */ `
  mutation UpdateDeviceQualityReasoning(
    $input: UpdateDeviceQualityReasoningInput!
  ) {
    updateDeviceQualityReasoning(input: $input) {
      createAt
      endDate
      id
      outdated
      reasoningId
      reasoningText
      reasoningType
      reviewed
      startDate
      updateBy
      updatedAt
      value
      __typename
    }
  }
`;
export const updateSubDevice = /* GraphQL */ `
  mutation UpdateSubDevice($input: UpdateSubDeviceInput!) {
    updateSubDevice(input: $input) {
      building
      contract_holder
      description
      deviceId
      id
      lessor
      name
      siteId
      __typename
    }
  }
`;
export const updateSubDeviceTimeseries = /* GraphQL */ `
  mutation UpdateSubDeviceTimeseries($input: UpdateSubDeviceTimeseriesInput!) {
    updateSubDeviceTimeseries(input: $input) {
      items {
        deviceId
        id
        nextToken
        pagination {
          nextToken
          startedAt
          __typename
        }
        propertyId
        timeseries {
          grid_name
          likelihood_index_season_base
          likelihood_index_season_hc
          likelihood_index_season_hcb
          likelihood_index_season_hce
          likelihood_index_season_hch
          likelihood_index_season_hp
          likelihood_index_season_hpb
          likelihood_index_season_hpe
          likelihood_index_season_hph
          likelihood_index_season_ja
          likelihood_index_season_p
          likelihood_index_season_pointe
          monotone_cumulative_time_in_min
          monotone_end_date
          monotone_execution_time
          monotone_start_date
          nature
          read_reason
          reason
          sampling_rate_in_min
          season_class_dict
          source
          time
          value
          value_nature_absence
          value_nature_actual
          value_nature_brut
          value_nature_corrected
          value_nature_corrige
          value_nature_coupure_secteur
          value_nature_coupure_secteur_courte
          value_nature_debut_de_coupure_secteur
          value_nature_esti
          value_nature_estimated
          value_nature_estime
          value_nature_fin_de_coupure_secteur
          value_nature_importe_manuellement_par_le_metier_enedis
          value_nature_no_data
          value_nature_puissance_reconstituee_et_coupure_secteur
          value_nature_reel
          value_nature_regu
          value_season_base
          value_season_hc
          value_season_hcb
          value_season_hce
          value_season_hch
          value_season_hp
          value_season_hpb
          value_season_hpe
          value_season_hph
          value_season_ja
          value_season_p
          value_season_pointe
          value_source_airtable_manual_bills
          value_source_airtable_third_party_active_power_in_kwh
          value_source_airtable_third_party_energy
          value_source_enedis_active_power_daily_in_kwh
          value_source_enedis_billed_energy
          __typename
        }
        unit
        __typename
      }
      nextToken
      scannedCount
      startedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      email
      enabled
      excludedPerimeter {
        devices
        sites
        __typename
      }
      id
      lastConnectionAt
      perimeter {
        devices
        sites
        __typename
      }
      role
      timeConstraintPerimeter {
        devices {
          id
          periods {
            endDate
            startDate
            __typename
          }
          __typename
        }
        sites {
          id
          periods {
            endDate
            startDate
            __typename
          }
          __typename
        }
        __typename
      }
      username
      __typename
    }
  }
`;
